import { isAdmin, isDataAdmin, isSuperAdmin } from '../../../utils/roleUtils'
import { selectCurrentUserRole } from '../../../features/auth/authSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useMasterData } from '../../../hooks/api/useMasterData'
import { resetClientForm } from '../../../features/client/clientSlice'
import { setTypeOfShowModalType } from '../../../features/modal/modalSlice'
import { FluentFormNew20Filled } from '../../../assets/icons/Icons'
import Refetch from '../../ui/Refetch'

export default function ClientOptionSorting() {

    const { refetchClients } = useMasterData()
    const dispatch = useDispatch()
    const adminRole = useSelector(selectCurrentUserRole)
    // const hasNewClientPermission = isDataAdmin(adminRole) || isSuperAdmin(adminRole) || isAdmin(adminRole)
    const hasNewClientPermission = isDataAdmin(adminRole) || isSuperAdmin(adminRole)

    return (
        <div className='w-full flex flex-col'>
            <div className={`flex justify-between`}>
                <p className='text-sm font-medium flex items-center justify-center'>
                    {'Client List'}
                </p>
                <div className='flex space-x-2'>
                    {hasNewClientPermission && (
                        <div className='flex space-x-2'>
                            <button 
                                onClick={() => {
                                    dispatch(resetClientForm())
                                    dispatch(setTypeOfShowModalType('newClient'))
                                }}
                                className='flex items-center text-sm font-medium rounded transition px-3 py-1 bg-cbColor text-white shadow-md'
                            >
                                <FluentFormNew20Filled/>
                            </button>
                        </div>
                    )}
                    <Refetch refetch={refetchClients} size={23} btnStyle={''}/>
                </div>
            </div>
        </div>
    )
}
